<template>
    <div class="table table-responsive">
        <table class="table table-responsive table-striped table-bordered d-table">
            <thead>
            <tr>
                <td style="width:3%">#</td>
                <td style="width:90%">Paragraph</td>
                <td>Delete</td>
            </tr>
            </thead>
            <draggable v-model="items" tag="tbody" @end="checkMove">
                <tr v-for="(item, itemIndex) in items" :key="item.order">
                    <td> <i style="font-size: 2em" class="fas fa-arrows-alt"></i></td>
                    <td>
                        <select-component
                            :name="'word_paragraphs['+itemIndex+']'"
                            url-search="/word_paragraphs/list-of-choices"
                            :url-show="'/word_paragraphs/show-choice/'+item.id"
                            :initial-value="item.id">
                        </select-component>
                    </td>
                    <td><a @click="deleteLine(item.id, itemIndex)" title="Delete"
                           class="btn btn-danger text-white"><span
                        class="fa fa-trash"></span></a></td>
                </tr>
            </draggable>
            <tfoot>
            <tr>
                <th colspan="9">
                    <button @click="addLine()" type="button"
                            class="btn btn-success"
                            data-toggle="tooltip"
                            data-original-title="Add more lines">
                        <i class="glyphicon glyphicon-plus-sign"></i>
                        Add
                    </button>

                </th>

            </tr>
            </tfoot>
        </table>
    </div>
</template>

<script>
import _ from "lodash";
import draggable from 'vuedraggable'
import WordParagraph from "../../../models/WordParagraph";

export default {
    name: "WordParagraphs",
    components: {
        draggable,
    },
    props: {},
    data: function () {
        return {
            items: [],
            order: 0,
        }
    },
    mounted() {

    },
    methods: {
        addLine() {
            let item = new WordParagraph()
            item.order = ++this.order
            item['index'] = item.order
            this.items.push(item);
        },
        deleteLine(id, itemIndex) {
            if (id) {
                this.$loading(true);
                let app = this;
            } else {
                this.items.splice(itemIndex, 1);
            }

        },
        checkMove: function () {

            for (let i = 0; i < this.items.length; i++) {
                this.items[i].index = i + 1;
            }
        },
    }
}
</script>

<style scoped>

</style>
